// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ding-input[data-v-49204ee3]{border:none;padding:.375rem 1.2rem!important;background:#f2f7f8;height:auto!important}[data-v-49204ee3] .intl-phone-input.allow-dropdown input[type=text]{border:none;background-color:#f2f7f8;padding-top:1.2rem;padding-bottom:1.2rem;font-size:inherit}[data-v-49204ee3] .intl-phone-input.allow-dropdown input[type=text]:focus{background-color:#fff;border-color:#ffe681;box-shadow:0 0 0 .2rem rgba(255,204,1,.25)}", ""]);
// Exports
module.exports = exports;
